<script setup lang="ts">
/**
 * Toast Countdown
 * --------------------------------
 * Countdown toast, e.g. for reservation time left
 */

const { toast } = defineProps<{
    toast: Toast;
}>();
const { t: $t, te: $te } = useNuxtApp().$i18n;
const countdown = ref('');
const diff = ref(0);
let interval: NodeJS.Timeout;
const localeRoute = useLocaleRoute();

/**
 * Update the countdown every second
 * - if time is up, redirect back to cart/address or home page (if cart is empty)
 */
async function updateCountdown() {
    const confirmationTimeLimit = toast.data as Date;
    if (!confirmationTimeLimit) {
        return;
    }
    diff.value = confirmationTimeLimit.getTime() - zurichDate().getTime();
    const minutes = Math.floor(diff.value / 1000 / 60);
    const seconds = Math.floor(diff.value / 1000) % 60;
    countdown.value = `${minutes}:${seconds.toString().padStart(2, '0')}`;

    if (diff.value <= 0) {
        const cartStore = useCartStore();
        clearInterval(interval);

        // Notice tracking: T2
        analyticsTrackEvent({
            event: 'notice',
            notice_element_item: 'checkout',
            notice_message: $te(toast.message) ? $t(toast.message, { time: '00:00' }) : toast.message,
        }, 'analyticsTrackToastCountdownTimeout');

        if (cartStore.offers.length > 0) {
            await navigateTo(localeRoute({ name: 'checkout-checkout-2-address' })?.href, { external: true });
        }
        else {
            await navigateTo('/', { external: true });
        }
    }
}

onMounted(() => {
    interval = setInterval(updateCountdown, 1000);
    updateCountdown();
});

onUnmounted(() => {
    clearInterval(interval);
});
</script>

<template>
    <Toast :toast="toast" class="bg-accent-1 text-white">
        <template #icon>
            <Icon name="tot:clock" class="size-4" />
        </template>
        <div>
            {{ $te(toast.message) ? $t(toast.message, { time: countdown }) : toast.message }}
        </div>
    </Toast>
</template>
